import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Box, Text, Anchor, TextArea, TextInput, CheckBox } from 'grommet';
import ReactTable from "react-table";
import Pagination from '../Components/Pagination';
import pdf from '../Assets/document/pdf/modulo_evasione_con_altri_mezzi.pdf'
import { EboxDetailCtrl } from '../Controllers/Ebox/EboxDetailCtrl';
import { DownloadAllegatoCtrl } from '../Controllers/Ebox/DownloadAllegatoCtrl';
import { UploadAllegatoCtrl } from '../Controllers/Ebox/UploadAllegatoCtrl';
import { DISPUTE_NOTE_MAX_LENGTH } from '../Constants.js';
import ModalErrorTimeout from './ModalErrorTimeout';
import ModalError from './ModalError';
import 'react-accessible-accordion/dist/fancy-example.css';
import { dateConvert, noData, loader, AllegatiList, maskCardNumber } from '../Utils/Utility';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton
} from 'react-accessible-accordion';


 class GestioneRichiesteStep4 extends Component {
    static propTypes = {
		match: PropTypes.object.isRequired,
		location: PropTypes.object.isRequired,
		history: PropTypes.object.isRequired
	}
    constructor(props) {
        super(props)
        this.state = {
            cb_evasione: false,
            msgEse:"",
            gestore:'',
            showTimeoutModal: false,
            showModalError: false,
            selectedFile:[],
            data: {},
            dataAllegato: [],
            dataUploadAllegato: {},
            doc:'',
            path:'',
            status: '',
            valueFile: [],
            fileNames: [],
            items:[],
            loading: true
        }
        this.getGestore = this.getGestore.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleDeleteItem = this.handleDeleteItem.bind(this);
        this.setCheckbox = this.setCheckbox.bind(this);
        this.setMessage = this.setMessage.bind(this);
        //this.blockEnter = this.blockEnter.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }


    componentWillMount() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
		const self=this;
		EboxDetailCtrl(function(data) {
			self.setState({
				data: data === undefined ? [] : data,
				//pagination: data.pagination,
				//status: status,
				loading:false
			});
		}, function(error) {
            self.setState({
                status: error
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                    // logout();
                    // this.props.history.push({
                    // pathname: '/login'
                    // })
                }
            })
		}, /*this.props.location.caseId,*/ this.props.values.gestore, token, ids);
    }

    back = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }

    getGestore(el) {
        this.setState({
            gestore: "Gestore " + el.selectedCode
        })
    }

    requestAllegato(doc, path) {
        this.setState({
            doc: doc,
            path: path
        }, () => {
            var token = sessionStorage.getItem('token')
            var ids = sessionStorage.getItem('ids')
            const self=this;
            DownloadAllegatoCtrl(function(data) {
                self.setState({
                    dataAllegato: data === undefined ? [] : data,
                    //pagination: data.pagination,
                    //status: status,
                    //loading:false
                })
                    const file = new Blob([data], {type: 'application/pdf'});
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                
                
            }, function(error) {
                self.setState({
                    status: error
                }, function(){
                    if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        // pathname: '/login'
                        // })
                    }
                })
            }, this.state, token, ids);
                
        })
    }

    getAllegati(row) {
        
        return row._original.allegatiList.map(item => (
            <button
                type="button"
                style={ item.documento === '' ? { display: 'none', background: 'none', border: 'none', padding: 0 } : { display: 'block', background: 'none', border: 'none', padding: 0 } }
                onClick={() => this.requestAllegato(item.documento, item.path)}
                aria-label={`Scarica allegato: ${item.documento}`}
            >
                <i className="icon icon-allegato icon-note" aria-hidden="true" />
            </button>
        ))

    }

    removeEmptyElement(data) {
        var filtered = data.filter(function (el) {
            return el !== "";
          });
        return filtered
    }


    handleInput(event) {
        let fileNames = this.state.fileNames;
        let files = event.target.files[0];
        if(files) {
            fileNames.push(files.name)
            const valueFile = this.state.valueFile;
            valueFile.push(files);

            this.setState({
                valueFile: valueFile,
                selectedFile: files,
                fileNames: fileNames
            })
        }
    }

    handleDeleteItem(itemId) {
        
        const updatedItems=this.state.valueFile;
        const updatedFilenames=this.state.fileNames;
        updatedItems.splice(updatedFilenames[itemId])
        updatedFilenames.splice(itemId, 1)
        
        this.setState({
            valueFile: updatedItems,
            fileNames: updatedFilenames
        })
    }

    setCheckbox() {
        this.setState({
            cb_evasione: !this.state.cb_evasione
        })
    }

    setMessage(event) {
        const msgEse = event.target.value.slice(0, DISPUTE_NOTE_MAX_LENGTH);

        this.setState({
            msgEse: msgEse
        })
    }

    uploadForm(){
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self=this;
        UploadAllegatoCtrl(function(data, status) {
            self.setState({
                dataUploadAllegato: data === undefined ? [] : data,
                status: status
            }, function(){
                if(data.esito === 'OK') {
                    this.props.history.push({
                        pathname: '/ResultPage'
                    })
                } else {
                    self.props.history.push({
                        pathname: '/ErrorPage',
                        path: "dispute"
                    })
                } 
            })
        }, function(error) {
            self.setState({
                status: error
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    self.props.history.push({
                        pathname: '/ErrorPage',
                        path: "dispute"
                    })
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                }
            })
        }, this.state, token, ids);
    }

    invia = () => {
        if(this.state.cb_evasione || this.state.valueFile.length > 0 || this.state.msgEse !== '') {
            this.uploadForm();
        } else {
            this.setState({
                showModalError: true
            })
        }
        // if(this.state.cb_evasione) {
        //     this.uploadForm();
        // } else {
        //     if( this.state.items.length > 0 ) {
        //         this.uploadForm();
        //     } else if(this.state.items.length == 0) {
        //         if(this.state.msgEse === "") {
        //             this.setState({
        //                 showModalError: true
        //             })
        //         } else {
        //             this.uploadForm();
        //         }
        //     }
        // }
    }

    closeModal(){
        this.setState({
            showModalError: false
        })
    }


    render() {

        const data = this.state.data !== undefined && this.state.data !== {} ? this.state.data : {};
        const documenti = data.requestDocList ? this.removeEmptyElement(data.requestDocList).map (item => <li>{item}</li>) : [];
        const dataStorico = data.messagesList ? data.messagesList : [];
        const size = dataStorico.length < 10 ? dataStorico.length : 10;
        //const dataAllegati = dataStorico !== [] && dataStorico.allegatiList !== undefined ? dataStorico.allegatiList.map(item => (
//  <button type="button" aria-label={`Scarica allegato: ${item.documento}`} style={{ background: 'none', border: 'none', padding: 0 }} onClick={() => this.requestPdf(item.documento, item.path)}>
//    <i className='icon-note' aria-hidden="true" title={item.documento}></i>
//  </button>
//)) : []

        const columns = [
            {
                Header: 'Data creazione',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => dateConvert(row.original.dataCreazione)
            },

            {
                Header: 'Stato',
                accessor: 'statoEbox',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Messaggio',
                accessor: 'testo',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Allegati',
                accessor: 'indirizzo',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (props) =>  this.getAllegati(props.row)

            },


        ]

        let practiceState = sessionStorage.getItem("practiceState");
        
        return (
                    <Box className='contentbox'>
                        {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                        {this.state.showModalError ? <ModalError type="dispute" closeModal={this.closeModal}/> : ''}
                        <Box align='start' style={{ margin: '20px 22px ' }}>
                            <Text className='titlehome'><h1>DISPUTE ONLINE - DETTAGLIO PRATICA</h1></Text>
                        </Box>
                        
                        {this.state.loading ?
                            
                            loader
                        :
                    
                        <Box style={{ padding: '24px 20px' }}>

                            <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Dati pratica
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='row' className='accordionText'>
                                            <Box>
                                                <Text>Numero pratica</Text>
                                                <Text>Tipo pratica</Text>
                                                <Text>Data apertura</Text>
                                                <Text>Stato</Text>
                                            </Box>
                                            <Box>
                                                <Text>{data.number}</Text>
                                                <Text>{data.practiceType}</Text>
                                                <Text>{dateConvert(data.openingDate)}</Text>
                                                <Text>{data.state}</Text>
                                            </Box>
                                        </Box>
                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Dati esercente
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>

                                        <Box direction='row' className='accordionText'>
                                            <Box>
                                                <Text>Codice societario</Text>
                                                <Text>Codice esercente</Text>
                                                <Text>Insegna / località</Text>
                                            </Box>
                                            <Box>
                                                <Text>{data.codSoc}</Text>
                                                <Text>{data.codPoS}</Text>
                                                <Text>{data.signLocale}</Text>
                                            </Box>

                                        </Box>


                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Dati operazione
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='row' className='accordionText'>
                                            <Box>
                                                <Text>Data</Text>
                                                <Text>Ora</Text>
                                                <Text>Numero carta</Text>
                                                <Text>Importo lordo (euro)	</Text>
                                                <Text>Numero autorizzazione	</Text>
                                                <Text>Codice terminale	</Text>
                                                <Text>Numero operazione	</Text>
                                                <Text>ARN</Text>
                                            </Box>
                                            <Box>
                                                <Text>{dateConvert(data.transDate)}</Text>
                                                <Text>{data.hour}</Text>
                                                <Text>{maskCardNumber(data.card)}</Text>
                                                <Text>{data.transAmount}</Text>
                                                <Text>{data.autorization}</Text>
                                                <Text>{data.codTerm}</Text>
                                                <Text>{data.numOper}</Text>
                                                <Text>{data.arn}</Text>
                                            </Box>
                                        </Box>

                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Documentazione richiesta
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='column' className='accordionText'>
                                            <Text>
                                                {documenti}
                                            </Text>
                                        </Box>

                                    </AccordionItemPanel>
                                </AccordionItem>


                                {practiceState === "nuove" || practiceState === "sospeso" || practiceState === "scadenza" ?
                                    <AccordionItem>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                Allega/Visualizza documentazione
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <Box direction='column' className='accordionText'>
                                                <TextInput accept='.pdf,.txt,.tif,.tiff' type="file" onChange={this.handleInput}/>
                                                <AllegatiList items={this.state.fileNames} deleteItem={this.handleDeleteItem} />
                                            </Box>

                                        </AccordionItemPanel>
                                    </AccordionItem>
                                : ""}

                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Evadi richiesta via fax/posta
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='column' className='accordionText'>
                                            <Text>
                                                Se sei momentaneamente impossibilitato ad utilizzare Dispute Online per
                                                la documentazione richiesta, puoi inviarcela via fax al numero 02 34889146
                                                oppure via posta all'indirizzo Dispute Esercenti Amex - Corso Sempione 55
                                                20145 Milano, allegandola al modulo preimpostato.
                                            </Text>
                                            <Box direction='row' id='checkboxDispute'>
                                                <CheckBox className='checkbox' color='#006FCF' checked={this.state.cb_evasione} id='evasione' onChange={this.setCheckbox} />
                                                <Anchor style={{ margin: '10px' }} href={pdf} target='blank'>Scarica documento</Anchor>
                                            </Box>

                                        </Box>
                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Messaggi
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='row' className='accordionText' gap='large'>
                                            <Box>
                                                <Text>Inserisci qui eventuali messaggi</Text>
                                                <TextArea
                                                    placeholder=""
                                                    value={this.state.msgEse}
                                                    maxLength={DISPUTE_NOTE_MAX_LENGTH}
                                                    onChange={this.setMessage}
                                                    aria-describedby='dispute-note-counter'
                                                />
                                                <Box align='end' style={{ width: '100%' }}>
                                                    <Text id='dispute-note-counter' aria-live='polite'>
                                                        {DISPUTE_NOTE_MAX_LENGTH - this.state.msgEse.length}/{DISPUTE_NOTE_MAX_LENGTH}
                                                    </Text>
                                                </Box>
                                            </Box>
                                            <Box>
                                                <Text>Messaggi da American Express</Text>
                                                <TextArea value={data.message !== "" ? data.message : ""} readOnly></TextArea>
                                            </Box>
                                        </Box>
                                    </AccordionItemPanel>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            Storico pratica
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <Box direction='column' className='accordionText' gap='large'>
                                            {size !== 0 ?
                                                <ReactTable
                                                    PaginationComponent={Pagination}
                                                    data={dataStorico}
                                                    columns={columns}
                                                    sortable={true}
                                                    multiSort={true}
                                                    resizable={true}
                                                    showPagination={true}
                                                    loading={false}
                                                    defaultPageSize={size}
                                                    style={{ paddingBottom: '20px' }} />

                                                : 
                                            
                                                noData}
                                        </Box>
                                    </AccordionItemPanel>
                                </AccordionItem>
                            </Accordion>

                            <Box direction='row' align='center' style={{margin:'0 auto'}}>
                                <Button className='btnform' style={{ width: '170px', margin: '32px 30px 0 0'  }} onClick={this.back}>INDIETRO</Button>
                                {practiceState === "nuove" || practiceState === "sospeso" || practiceState === "scadenza" ?
                                    <Button className='btnform' style={{ width: '170px', marginTop: "32px" }} onClick={this.invia}>INVIA</Button>
                                : ""}
                            </Box>
                        </Box>
                        }
                    </Box>
                

        )
    }
}

export default GestioneRichiesteStep4 = withRouter(GestioneRichiesteStep4);
